import { ReactChild, ReactFragment, useEffect, useState } from "react";
import Image from "next/image";
import styles from "../styles/Home.module.css";
import { Box, Button, Heading, Text, Flex, Link } from "rebass";
import { useTheme, ThemeProvider, withTheme } from "@emotion/react";
import styled from "styled-components";
import { Tiles } from "@rebass/layout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faTwitter, faDiscord, faMedium, faInstagram, IconLookup } from '@fortawesome/free-brands-svg-icons'
import { faAt, faCube } from '@fortawesome/free-solid-svg-icons';
import { faFileZipper, faFileArchive } from '@fortawesome/free-regular-svg-icons';


const Footer = () => {
  const socialLink = (icon: IconLookup, name: string, color: string, link: string | null,) => {
    return (
      <Button
        onClick={() => { link && window.open(link)?.focus() }}
        sx={{
          backgroundColor: "#121212",
          cursor: "pointer",
          border: "1px solid #343434",
          borderRadius: "20px",
          padding: "20px",
          ':hover': {
            backgroundColor: '#333333',
          }
        }}
      >
        <Flex sx={{justifyContent:"center", alignItems: "center", gap: '8px'}}>
        <FontAwesomeIcon icon={icon} style={{ color: color, fontSize: '25px', zIndex: 99 }} />
        <Text >{name}</Text>
        </Flex>
      </Button>
    );
  };

  return (
    <Flex
      width={0.7}
      flexDirection="column"
      m="0 auto"
      justifyContent="center"
      alignItems="center"
      my="30px"
      sx={{gap: '8px'}}
    >
        {socialLink(faDiscord, 'Join our community', "#5661EA", 'https://discord.gg/DtZkFTay2U')}
      <Tiles
        columns={[1, 2, 4]}
        sx={{ justifyItems: "center", userSelect: "none", my: '20px' }}
      >
          {socialLink(faTwitter, 'Twitter', "#1DA1F3",  'https://twitter.com/lilico_app')}
          {/* {socialLink(faMedium, 'Medium', "#000000",  'https://medium.com/@outblock')} */}
          {socialLink(faInstagram, 'Instagram', "#F14B5D",'https://www.instagram.com/lilico_app')}
          {socialLink(faAt, 'Email', "#FC814A",'mailto:hi@lilico.app')}
          <a download href="/files/lilico-media-kit.zip">
          {socialLink(faFileArchive, 'Media Kit', "#7678ED", null)}
          </a>
      </Tiles>

      <Flex sx={{gap: '4px'}}>
        <Link variant='nav' href="/about/terms">{'Terms & Conditions'}</Link>
        <Link variant='nav' href="/about/privacy-policy">{' - Privacy'}</Link>
    </Flex>
    <Flex sx={{gap: '4px'}}>
    
    <Text sx={{color: '#5e5e5e'}} >{"Copyright © 2022 - "}</Text>
    <Link sx={{color: '#5e5e5e'}} href="https://outblock.io">{'  '}Outblock</Link>
    </Flex>
    </Flex>
  );
};

export default Footer;
